<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push('/home').catch(() => {})"
        :content="$t('cockpit-prepostagem')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-card shadow="hover">
        <el-form :model="ruleForm" :inline="true" ref="ruleForm">
          <el-form-item :label="$t('periodo')" prop="name">
            <el-date-picker
              v-model="ruleForm.range"
              type="daterange"
              align="right"
              unlink-panels
              clearable
              range-separator="à"
              format="dd/MM/yyyy"
              start-placeholder="Inicio"
              end-placeholder="Fim"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('cliente')" prop="name">
            <CustomerList v-model="ruleForm.customer" v-bind:multiple="true" />
          </el-form-item>
          <el-form-item :label="$t('servico')" prop="name">
            <ServicesList v-model="ruleForm.service" />
          </el-form-item>
          <!--el-drawer title="Filtro" :visible.sync="drawer" size="50%">
          </!--el-drawer>
          <el-button style="float: right" @click="drawer = true">{{
            $t("mais-filtros")
          }}</el-button>
          <el-drawer
            :title="$t('outras-consultas')"
            :visible.sync="panels"
            size="30%"
          >
            <div style="margin-left: 30px">
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("prepostagem") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("postagens") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("curva-abc") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("ordem-servico") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("auditoria") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("conferencia-objetos") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("consulta-dh") }}
                </el-col>
              </el-row>
              <el-row gutter="5">
                <el-col :xs="12" :sm="6" :md="6" :lg="24" :xl="24">
                  <el-switch ref="user" v-model="ruleForm.user"></el-switch>
                  {{ $t("logistica-reversa") }}
                </el-col>
              </el-row>
              <br />
              <div style="text-align: center">
                <el-button type="primary" @click="panels = false"
                  >Fechar</el-button
                >
              </div>
            </div>
          </el-drawer>
          <el-button
            style="float: right; margin-right: 3px"
            @click="panels = true"
            >{{ $t("outras-consultas") }}</el-button
          -->
        </el-form>
      </el-card>
      <br />
      <el-row :gutter="5">
        <OrderServicesList />
      </el-row>
      <br />
      <el-row :gutter="5">
        <el-col
          v-show="!id || id === 'curvaabc'"
          :lg="id == 'curvaabc' ? 24 : 12"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("curva-abc") }}</span>
              <el-form
                style="float: right; padding: 3px 0"
                :model="ruleForm"
                inline="true"
                :rules="rules"
                ref="ruleForm"
              >
                <el-form-item :label="$t('agrupar')" prop="name">
                  <el-select v-model="value" placeholder="Select">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <el-table
              :data="
                tableData.filter(
                  (data) =>
                    !filter ||
                    data.name.toLowerCase().includes(filter.toLowerCase()) ||
                    data.companyname
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    data.federalid.toLowerCase().includes(filter.toLowerCase())
                )
              "
              stripe
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column
                sortable
                prop="service"
                :label="$t('servico')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="package"
                :label="$t('qtde')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('valor-tab')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('valor')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('%')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('seguro')"
              ></el-table-column>
              <el-table-column
                prop="services"
                :label="$t('curva-abc')"
              ></el-table-column>
            </el-table>
            <div class="bottom clearfix">
              <el-row :gutter="5">
                <el-col :lg="10">
                  <el-pagination
                    layout="prev, pager, next"
                    :total="1"
                  ></el-pagination>
                </el-col>
                <el-col :lg="3" style="margin-top: 2px; float: right">
                  <el-dropdown>
                    <el-button>
                      Exportar
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>XLS</el-dropdown-item>
                      <el-dropdown-item>PDF</el-dropdown-item>
                      <el-dropdown-item>HTML</el-dropdown-item>
                      <el-dropdown-item>CSV</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <BudgetList />
      </el-row>
    </el-card>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import PostList from "./prepost/PostList";
import OrderServicesList from "./prepost/OrderServicesList";
import AuditList from "./prepost/AuditList";
import ReverseLogisticsList from "@/xpost/views/services/reverse.logistics/ReverseLogisticsList";
import BudgetList from "./prepost/BudgetList";
import ComponentStateEnum from "@/xpost/enums/ComponentStateEnum";

export default {
  name: "CockpitPrepost",
  components: {
    CustomerList,
    ServicesList,
    OrderServicesList,
    AuditList,
    PostList,
    ReverseLogisticsList,
    BudgetList,
  },
  enums: {
    ComponentStateEnum,
  },
  methods: {
    maximize(id) {
      const vm = this;
      if (vm.id === id) {
        vm.state = ComponentStateEnum.LESS;
        vm.id = null;
        return false;
      }
      vm.state = ComponentStateEnum.MORE;
      vm.id = id;
    },
    fetchRecords() {
      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    vm.state = ComponentStateEnum.LESS;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      id: null,
      drawer: false,
      innerDrawer: false,
      panels: false,
      panelDrawer: false,
      dialogFormVisible: true,
      state: ComponentStateEnum.LESS,
      services: [],
      tableData: [],
      tableService: [
        {
          code: "04014",
          name: "SEDEX sem contrato",
        },
        {
          code: "04804 ",
          name: "SEDEX Hoje, sem contrato",
        },
      ],
      tablePost: [],
      ruleForm: {
        range: [],
        customer: "",
        service: "",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>